import { RawPatient } from 'core/models/patientModel';
import { Sensor } from './sensorModal';

export interface PatientBase {
  id: string;
  firstName: string;
  lastName: string;
  subjectId?: string;
  name?: string;
  timeZoneName?: string;
}

export class PatientModelBase implements PatientBase {
  id: string;

  firstName: string;

  subjectId?: string;

  lastName: string;

  name?: string;

  sensors?: Sensor[];

  constructor(data: RawPatient) {
    this.id = data.id;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.name = data.name;
    this.sensors = data.sensors;
    this.subjectId = data.subjectId;
  }
}
